import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../ui/Logo';
import ThemeToggle from '../ui/ThemeToggle';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState('ES');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: 'Inicio' },
    { path: '/nosotros', label: 'Nosotros' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/metodologia', label: 'Metodología' }
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleLanguageMenu = () => {
    setIsLanguageMenuOpen(!isLanguageMenuOpen);
  };

  const handleLanguageChange = (lang) => {
    setCurrentLanguage(lang);
    setIsLanguageMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="container">
        <div className="header__content">
          <Link to="/" className="header__logo">
            <Logo width={100} />
          </Link>

          <nav className={`header__nav ${isMobileMenuOpen ? 'header__nav--open' : ''}`}>
            <ul className="header__nav-list">
              {navItems.map((item) => (
                <li key={item.path} className="header__nav-item">
                  <Link 
                    to={item.path} 
                    className={`header__nav-link ${location.pathname === item.path ? 'header__nav-link--active' : ''}`}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="header__actions">
            <div className="header__language-selector">
              <button 
                className="header__language-toggle"
                onClick={toggleLanguageMenu}
                aria-label="Select language"
              >
                <svg className="header__language-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="2" y1="12" x2="22" y2="12"/>
                  <path d="m8 12c0-4.97 1.79-9 4-9s4 4.03 4 9-1.79 9-4 9-4-4.03-4-9z"/>
                </svg>
                <span className="header__language-current">{currentLanguage}</span>
              </button>
              
              {isLanguageMenuOpen && (
                <div className="header__language-menu">
                  <button 
                    className={`header__language-option ${currentLanguage === 'ES' ? 'active' : ''}`}
                    onClick={() => handleLanguageChange('ES')}
                  >
                    <span className="header__flag">🇪🇸</span>
                    <span>ES</span>
                  </button>
                  <button 
                    className={`header__language-option ${currentLanguage === 'EN' ? 'active' : ''}`}
                    onClick={() => handleLanguageChange('EN')}
                  >
                    <span className="header__flag">🇺🇸</span>
                    <span>EN</span>
                  </button>
                </div>
              )}
            </div>
            
            <ThemeToggle />
            
            <button 
              className="header__mobile-toggle"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              <span className={`hamburger ${isMobileMenuOpen ? 'hamburger--open' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
